import type { StorageInstance } from 'storage/domain/Storage'
import type { MasterData } from 'types/masterData'
import { sessionCache } from '../sessionCache'

export const removeSessionCache = async (
	masterData: MasterData
): Promise<void> => {
	try {
		const sessionStorage: StorageInstance = sessionCache(masterData)

		await sessionStorage.clean()
	} catch {
		throw new Error('[Session] Error to remove session data on IndexedDB')
	}
}
